import React, {useContext, useEffect} from 'react';
import {TitleContext} from 'components/TitleContext';
import ReportFinderTable from 'features/reportFinder/ReportFinderTable';
import {UserHrDocumentThunks} from 'features/userHrDocument/userHrDocumentThunks';
import useViewerModal from 'hooks/useViewerModal';
import {UserTrainingThunks} from 'features/userTraining/userTrainingThunks';
import {UserApplicationThunks} from 'features/userApplication/userApplicationThunks';
import {UserMedicalDocumentThunks} from 'features/userMedicalDocument/userMedicalDocumentThunks';
import {UserBackgroundDocumentThunks} from 'features/userBackgroundDocument/userBackgroundDocumentThunks';
import {UserCredentialThunks} from '../../features/userCredential/userCredentialThunks';
import {UserJobRoleThunks} from 'features/userJobRole/userJobRoleThunks';
import {UserEvaluationThunks} from 'features/userEvaluation/userEvaluationThunks';
import {DocumentTemplateSolutionThunks} from '../../features/documentTemplateSolution/documentTemplateSolutionThunks';

const ReportFinderPage: React.FC = () => {
  const {setTitle} = useContext(TitleContext);

  const {AttachmentModal, handleNameClick, openModalForFile} =
    useViewerModal<any>({
      openDrawer: () => {},
      fetchItemThunk: (id: string) => {
        const [type, realId] = id.split(':');
        switch (type) {
          case 'HR Document':
            return UserHrDocumentThunks.show(realId);
          case 'Training':
            return UserTrainingThunks.show(realId);
          case 'Application':
            return UserApplicationThunks.show(realId);
          case 'Medical Document':
            return UserMedicalDocumentThunks.show(realId);
          case 'Background Document':
            return UserBackgroundDocumentThunks.show(realId);
          case 'Certification':
            return UserCredentialThunks.show(realId);
          case 'Role':
            return UserJobRoleThunks.show(realId);
          case 'Evaluation':
            return UserEvaluationThunks.show(realId);
          default:
            return UserHrDocumentThunks.show(id);
        }
      },
      fetchDocumentTemplateThunk: (args: any) => {
        return DocumentTemplateSolutionThunks.index(args);
      },
    });

  const handleViewerModal = (record: any) => {
    if (record.attachment) {
      openModalForFile(record.attachment.url, record.name || '');
    } else {
      handleNameClick(record);
    }
  };

  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']">
          Report Finder
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal">
          Find and manage documents across all users
        </div>
      </div>,
    );
  }, [setTitle]);

  return (
    <div className="">
      <div className="relative">
        <div className="">
          <div className="relative">
            <ReportFinderTable
              openViewerModal={handleViewerModal}
              openDrawer={() => {}}
            />
            <AttachmentModal />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportFinderPage;
